import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionDivider = styled(Box)(({ theme }) => ({
  position: 'relative',
  borderTop: `1px solid ${theme.palette.divider}`,
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: -9,
  left: 0,
  backgroundColor: theme.palette.background.paper,
  paddingRight: theme.spacing(1),
  fontSize: '0.625rem',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: theme.palette.text.disabled,
}));

export const FormWrapper = styled(Box)({
  '& .MuiInputLabel-root': {
    textAlign: 'left',
  },
});
